interface PROPS {
  hash_sha256_content: string;
}

export function G_IMAGE__view_loading({ hash_sha256_content }: PROPS) {
  /*
   * EFFECTS
   */

  /*
   * METHODS
   */
  function get_text() {
    return hash_sha256_content.is_empty_hash_sha256() ? 'Creating...' : 'Loading...';
  }

  /*
   * HTML
   */

  return <div className="view_image_loading nodrag relative size-full flex-center max-h-full">{get_text()}</div>;
}
